import React, { Fragment } from 'react';
import { withStyles } from 'tss-react/mui';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import educatorPassportLogo from '../../images/educator-passport.png';
import FlashMessages from '../../common/components/misc/FlashMessages';
import LoginLayout from './LoginLayout';

const styles = theme => ({
  backToLoginLink: {
    color: theme.typography.color.primary,
    '&:hover': {
      color: theme.typography.color.primary,
    },
    '&:visited': {
      color: theme.typography.color.primary,
    },
    fontSize: theme.typography.pxToRem(13),
    marginLeft: theme.typography.pxToRem(20),
  },
  loginActions: {
    marginTop: theme.typography.pxToRem(40),
  },
  loginHeader: {
    marginBottom: theme.typography.pxToRem(20),
  },
  loginLogo: {
    marginBottom: theme.typography.pxToRem(30),
  },
});

const SSOLoginForm = (props) => {
  const { classes } = props;

  var urlHash = window.location.hash.replace("#", "")
  console.log({ urlHash })
  if (urlHash.includes("code=")) {
    window.location = `/sso/signed_in?${urlHash}`;
    return
  }

  return (
    <Fragment>
      <div className={classes.loginLogo}>
        <img src={educatorPassportLogo} />
      </div>
      <Typography className={classes.loginHeader} variant="h6">
        Login
      </Typography>
      <FlashMessages flashMessages={props.flashMessages} />
      <form action="/sso/sign_in" method="post">
        <input type="hidden" name="authenticity_token" value={props.csrf} />
        <TextField
          variant="standard"
          autoFocus
          fullWidth
          id="email"
          label="Email"
          name="user[email]"
          type="email" />
        <Grid
          container
          alignItems="center"
          className={classes.loginActions}
        >
          <Button color="primary" type="submit" variant="contained">
            Continue
          </Button>
        </Grid>
      </form>
    </Fragment>
  );
};

const StyledLoginForm = withStyles(SSOLoginForm, styles, { withTheme: true });
const SSOLoginApp = (props) => {
  return (<LoginLayout><StyledLoginForm {...props} /></LoginLayout>);
};

export default SSOLoginApp;
